import { Box, Button, Dialog } from "@mui/material";

export default function CommissioningUserAgreement({ open, onClose, onAgree, alreadyAccepted }) {
  const handleAccept = () => {
    onAgree(true);
    onClose();
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog open={open} onClose={() => onClose()} fullWidth maxWidth="md">
      <Box sx={{ m: 3 }}>
        <ol>
          <li>
            <i>Certification of Correct Installation</i>
            <p>
              The installing party hereby certifies that the installation of the battery energy storage system and/or
              photovoltaic (PV) system has been executed in full compliance with all applicable legislation, technical
              standards, and the manufacturer's installation guidelines. The work was performed by qualified and
              certified personnel, adhering to all safety protocols and quality assurance standards.
            </p>
          </li>
          <li>
            <i>Inspection by Accredited Inspection Body</i>
            <p>
              The installing party confirms that the installation has been subjected to and successfully passed an
              inspection carried out by a recognized and officially accredited inspection body. The corresponding
              inspection report will be included in the project completion file or, where applicable, made available
              separately to the client.
            </p>
          </li>
          <li>
            <i>Processing of Personal Data (GDPR)</i>
            <p>
              The installing party declares that it has obtained the customer's consent to access and process their
              personal data, including consumption data and system information, for the purposes of system installation,
              monitoring, and maintenance, in accordance with applicable data protection regulations (GDPR).
            </p>
          </li>
        </ol>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: 3,
          }}
        >
          {alreadyAccepted ? (
            <Button onClick={handleClose}>Close</Button>
          ) : (
            <>
              <Button variant="contained" sx={{ marginRight: 5 }} onClick={handleAccept}>
                Accept
              </Button>
              <Button onClick={handleClose}>Decline</Button>
            </>
          )}
        </Box>
      </Box>
    </Dialog>
  );
}
